import { render, staticRenderFns } from "./addResult.vue?vue&type=template&id=44345cb5&"
import script from "./addResult.vue?vue&type=script&lang=js&"
export * from "./addResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports